import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Resize,
  Sort,
} from "@syncfusion/ej2-react-grids";
import {
  GenerateGpuWbExcelApi,
  GetAllMisc,
  getGPUbySoId,
  getGpuListByRma,
  getGPUsOrderbyStore,
  getInvPartsByFilter,
  getListBoxId,
  getPartsListByStoreFilter,
  getRmaList,
  PrintBoxQrCodeApi,
  PrintGpuRollerApi,
  PrintGpuStickerApi,
  PrintLogGPUApi,
  PrintRecvGPUApi,
  PrintRecvWBApi,
  PrintRMACodeApi,
  PrintRMAIDApi,
  PrintShipAssyApi,
  PrintTestDetailGPUApi,
  PrintTestGPUApi,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextInputField from "../../components/TextInputField";
import SelectField from "../../components/SelectField";
import DateInputField from "../../components/DateInputField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const GpuWbReport = () => {
  const navigate = useNavigate();
  const { companyG, storeG } = useStateContext();
  const gpuRef = useRef(null);
  const gridRef = useRef(null);
  const [Orders, setOrders] = useState([]);
  const [BoxIds, setBoxIds] = useState([]);
  const [RmaIds, setRmaIds] = useState([]);
  const [Partss, setPartss] = useState([]);
  const [Status, setStatus] = useState([]);
  const [Sns, setSns] = useState([]);
  const [formData, setFormData] = useState({
    type: "Select Type",
    order: "Select Order",
    part_no: "Select Part",
    status_: "Select Status",
    box: "Select Box ID",
    rma: "Select RMA ID",
    from_date: null,
    to_date: null,
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const reportTypes = [
    { label: "Box QR Code", value: 1 },
    { label: "GPU Labels Thermal", value: 2 },
    { label: "GPU Labels 10*3 Letterhead", value: 3 },
    { label: "RMA Report & Sticker", value: 4 },
    { label: "Receive WBs Report", value: 5 },
    { label: "Receive GPUs Report", value: 6 },
    { label: "Test GPUs Report", value: 7 },
    { label: "Test Detail GPUs Report", value: 8 },
    { label: "Ship Assemblies Report", value: 9 },
    { label: "Log GPUs History Report", value: 10 },
  ];

  const snsGrid = [
    {
      type: "CheckBox",
      width: "50",
    },
    {
      field: "gpu_sn",
      headerText: "GPU SN",
      minWidth: "80",
      width: "140",
      textAlign: "left",
    },
    {
      field: "status",
      headerText: "Status",
      minWidth: "80",
      width: "100",
      textAlign: "left",
    },
    {
      field: "test_result",
      headerText: "Test Res",
      minWidth: "40",
      width: "100",
      textAlign: "left",
    },
    {
      field: "test_scan_date",
      headerText: "Test Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "40",
      width: "125",
      textAlign: "center",
    },
    {
      field: "recv_scan_date",
      headerText: "Recv Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "40",
      width: "125",
      textAlign: "center",
    },
    {
      field: "so_id",
      headerText: "SO #",
      minWidth: "40",
      width: "80",
      textAlign: "center",
    },
  ];

  const handleRowSelected = (args) => {
    const indexx = gridRef?.current?.getSelectedRowIndexes() || [];
    setFormData((prev) => ({ ...prev, qty: indexx.length }));
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "sn") {
      if (value.length > 10 && value.length < 18) {
        const grid = gridRef?.current;
        const selected = grid?.getSelectedRowIndexes();
        const index = Sns.findIndex((item) => item.gpu_sn === value);
        if (index >= 0) {
          if (selected.includes(index)) grid.selectRows(selected);
          else grid.selectRows([...selected, index]);
        }
        setFormData((prev) => ({ ...prev, [name]: value }));
        gpuRef?.current?.focus();
      } else setFormData((prev) => ({ ...prev, [name]: value, gpu_id: 0 }));
    } else setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = async (option, e) => {
    if (option && option.value) {
      if (e.name === "type")
        setFormData((prev) => ({
          ...prev,
          [e.name]: option,
          order: "Select",
          box: "Select",
        }));
      else setFormData((prev) => ({ ...prev, [e.name]: option }));
      if (e.name === "order") {
        if (formData.type.value === 2 || formData.type.value === 3) {
          await getGPUbySoId(option.value)
            .then((resp) => setSns(resp.data || []))
            .catch((err) => console.log(err.message));
        } else if (formData.type.value === 1) {
          await getListBoxId(option.value)
            .then((resp) => {
              if (resp?.data?.length > 0) {
                const uniqueOpt = resp.data.filter(
                  (user, index, self) =>
                    index === self.findIndex((u) => u.box_id === user.box_id),
                );
                const options = uniqueOpt.map((item) => ({
                  label: item.box_id,
                  value: item.box_id,
                }));
                setBoxIds(options || []);
              }
            })
            .catch((err) => console.log(err.message));
        }
      }
      if (e.name === "rma")
        if (formData.type.value === 4)
          await getGpuListByRma(option.value)
            .then((resp) => setSns(resp.data || []))
            .catch((err) => console.log(err.message));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    const typp = formData.type?.value;
    let fD = null,
      tD = null,
      wo = "All",
      prt = "All",
      sts = "All";
    try {
      if (typp === 5 || typp === 6 || typp === 7 || typp === 8 || typp === 9) {
        if (!formData.from_date) {
          showErrorToast("Error!", "Select From Date!");
          setLoadBtn(false);
          return;
        } else if (!formData.to_date) {
          showErrorToast("Error!", "Select To Date!");
          setLoadBtn(false);
          return;
        } else if (formData.from_date > formData.to_date) {
          showErrorToast("Error!", "From Date cannot be later than To Date!");
          setLoadBtn(false);
          return;
        }
        fD = formData.from_date + "T00:00:00";
        tD = formData.to_date + "T23:59:59";
        wo = formData.order?.value || "All";
        prt = formData.part_no?.value || "All";
        sts = formData.status_?.value || "All";
      }
      let resp = false;
      if (typp === 1) {
        if (!formData.order?.value) showErrorToast("Error!", "Select Order!");
        else if (!formData.box?.value)
          showErrorToast("Error!", "Select BoxID!");
        else
          resp = await PrintBoxQrCodeApi(
            formData.order.value,
            formData.box.value,
          );
      } else if (typp === 2) {
        if (!formData.order?.value) showErrorToast("Error!", "Select Order!");
        else if (gridRef?.current?.getSelectedRowIndexes().length <= 0)
          showErrorToast("Error!", "Select one or more GPUs to print!");
        else {
          const gpu_sns = gridRef.current
            .getSelectedRecords()
            .map((row) => row.gpu_sn);
          const gpuStr = gpu_sns.join("|");
          resp = await PrintGpuRollerApi(gpuStr);
        }
      } else if (typp === 3) {
        if (!formData.order?.value) showErrorToast("Error!", "Select Order!");
        else if (gridRef?.current?.getSelectedRowIndexes().length <= 0)
          showErrorToast("Error!", "Select one or more GPUs to print!");
        else {
          const gpu_sns = gridRef.current
            .getSelectedRecords()
            .map((row) => row.gpu_sn);
          const gpuStr = gpu_sns.join("|");
          resp = await PrintGpuStickerApi(gpuStr);
        }
      } else if (typp === 4) {
        if (!formData.rma?.value) showErrorToast("Error!", "Select RMA!");
        else if (Sns.length <= 0) showErrorToast("Error!", "No GPUs to print!");
        else {
          const gpu_sns = Sns.map((row) => row.gpu_sn);
          const gpuStr = gpu_sns.join("|");
          resp = await PrintRMACodeApi(gpuStr);
          resp = await PrintRMAIDApi(gpuStr);
        }
      } else if (typp === 5) resp = await PrintRecvWBApi(prt, fD, tD);
      else if (typp === 6) resp = await PrintRecvGPUApi(wo, sts, prt, fD, tD);
      else if (typp === 7) resp = await PrintTestGPUApi(wo, fD, tD);
      else if (typp === 8) resp = await PrintTestDetailGPUApi(wo, fD, tD);
      else if (typp === 9) resp = await PrintShipAssyApi(wo, fD, tD);
      else if (typp === 10) {
        if (!formData.order?.value)
          showErrorToast("Error!", "Select Work Order!");
        else resp = await PrintLogGPUApi(formData.order?.value || "All");
      }
      if (resp) showSuccessToast("Success!", "Report Printed successfully!");
    } catch (err) {
      showErrorToast("Error!", "Report did not print!");
    } finally {
      setLoadBtn(false);
    }
  };

  const handleSubmitExc = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    try {
      const typp = formData.type.value;
      if (typp === 5 || typp === 6 || typp === 7 || typp === 8 || typp === 9) {
        if (!formData.from_date) {
          showErrorToast("Error!", "Select From Date!");
          setLoadBtn(false);
          return;
        } else if (!formData.to_date) {
          showErrorToast("Error!", "Select To Date!");
          setLoadBtn(false);
          return;
        } else if (formData.from_date > formData.to_date) {
          showErrorToast("Error!", "From Date cannot be later than To Date!");
          setLoadBtn(false);
          return;
        }
        const fD = formData.from_date + "T00:00:00";
        const tD = formData.to_date + "T23:59:59";
        const wo = formData.order?.value || "All";
        const prt = formData.part_no?.value || "All";
        const sts = formData.status_?.value || "All";
        const typ =
          typp === 5
            ? "RWB"
            : typp === 6
              ? "RGP"
              : typp === 7
                ? "TGP"
                : typp === 8
                  ? "TDG"
                  : "SAS";
        let resp = await GenerateGpuWbExcelApi(typ, wo, sts, prt, fD, tD);
        if (resp) showSuccessToast("Success!", "Excel generated successfully!");
      } else if (typp === 10) {
        if (!formData.order?.value)
          showErrorToast("Error!", "Select Work Order!");
        else {
          const wo = formData.order?.value || "All";
          let resp = await GenerateGpuWbExcelApi(
            "LGP",
            wo,
            "All",
            "All",
            "2001-01-01T00:00:00",
            "2001-01-01T00:00:00",
          );
          if (resp)
            showSuccessToast("Success!", "Excel generated successfully!");
        }
      }
    } catch (err) {
      showErrorToast("Error!", "Excel did not generate!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (companyG !== null && storeG && companyG.company_id !== 0) {
        TimeoutUtility.resetTimeout();
        const typp = formData.type?.value;
        if (typp !== 4 && typp !== 5)
          await getGPUsOrderbyStore(storeG.store_id, companyG.company_id)
            .then((resp) => {
              const options = resp.data.map((item) => ({
                label: item.so_id,
                value: item.so_id,
              }));
              setOrders(options || []);
            })
            .catch((err) => console.log(err.message));
        if (typp === 4)
          await getRmaList()
            .then((resp) => {
              const options = resp.data.map((item) => ({
                label: item,
                value: item,
              }));
              setRmaIds(options || []);
            })
            .catch((err) => console.log(err.message));
        if (typp === 5)
          await getPartsListByStoreFilter(storeG?.store_id, "water block")
            .then((resp) => {
              const partOptions = resp.data.map((item) => ({
                label: item.part_number,
                value: item.part_id,
              }));
              setPartss(partOptions || []);
            })
            .catch((err) => console.log(err.message));
        if (typp === 6) {
          await GetAllMisc("gpuwb/gpustatus")
            .then((resp) => {
              const typeOptions = resp.data.map((item) => ({
                label: item.name,
                value: item.status_id,
              }));
              setStatus(typeOptions || []);
            })
            .catch((err) => console.log(err.message));
          await getInvPartsByFilter(storeG?.store_id, null, 136)
            .then((resp) => {
              const partOptions = resp.data.map((item) => ({
                label: item.part_number,
                value: item.part_id,
              }));
              setPartss(partOptions || []);
            })
            .catch((err) => console.log(err.message));
        }
        if (
          typp === 5 ||
          typp === 6 ||
          typp === 7 ||
          typp === 8 ||
          typp === 9
        ) {
          const now = new Date();
          const fD = new Date(now.getFullYear(), now.getMonth(), 1);
          now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
          fD.setMinutes(fD.getMinutes() - fD.getTimezoneOffset());
          setFormData((prev) => ({
            ...prev,
            order: "Select",
            part_no: "Select",
            status_: "Select",
            from_date: fD.toISOString().slice(0, 19).split("T")[0],
            to_date: now.toISOString().slice(0, 19).split("T")[0],
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            order: "Select",
            box: "Select",
            rma: "Select",
          }));
          setSns([]);
        }
      }
    }
    fetchData();
  }, [storeG, companyG, formData.type]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="GPU / WATER BLOCK REPORTS" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={4} lg={4} className="container-col">
              <SelectField
                label="Report Type:"
                name="type"
                value={formData.type}
                options={reportTypes}
                onChange={handleSelectChange}
                placeholder="Report Type"
                error={errors.type}
              />
              {(formData.type?.value === 1 ||
                formData.type?.value === 2 ||
                formData.type?.value === 3 ||
                formData.type?.value === 6 ||
                formData.type?.value === 7 ||
                formData.type?.value === 8 ||
                formData.type?.value === 9 ||
                formData.type?.value === 10) && (
                <SelectField
                  label="Work Orders:"
                  name="order"
                  value={formData.order}
                  options={Orders}
                  onChange={handleSelectChange}
                  placeholder="Work Order"
                  isClearable
                  error={errors.order}
                />
              )}
              {formData.type?.value === 1 && (
                <SelectField
                  label="Box ID:"
                  name="box"
                  value={formData.box}
                  options={BoxIds}
                  onChange={handleSelectChange}
                  placeholder="Box ID"
                  error={errors.box}
                />
              )}
              {formData.type?.value === 4 && (
                <SelectField
                  label="RMA ID:"
                  name="rma"
                  value={formData.rma}
                  options={RmaIds}
                  onChange={handleSelectChange}
                  placeholder="RMA ID"
                  error={errors.rma}
                />
              )}
              {(formData.type?.value === 2 || formData.type?.value === 3) && (
                <TextInputField
                  ref={gpuRef}
                  label="GPU SN Scan:"
                  name="sn"
                  value={formData.sn}
                  onChange={handleChange}
                  placeholder="GPU SN"
                />
              )}
              {(formData.type?.value === 5 || formData.type?.value === 6) && (
                <SelectField
                  label="Part No:"
                  name="part_no"
                  value={formData.part_no}
                  options={Partss}
                  onChange={handleSelectChange}
                  placeholder="Part No"
                  isClearable
                  error={errors.part_no}
                />
              )}
              {formData.type?.value === 6 && (
                <SelectField
                  label="Status:"
                  name="status_"
                  value={formData.status_}
                  options={Status}
                  onChange={handleSelectChange}
                  placeholder="Status"
                  isClearable
                  error={errors.status_}
                />
              )}
              {(formData.type?.value === 5 ||
                formData.type?.value === 6 ||
                formData.type?.value === 7 ||
                formData.type?.value === 8 ||
                formData.type?.value === 9) && (
                <>
                  <DateInputField
                    label="From Date:"
                    name="from_date"
                    value={formData.from_date}
                    onChange={handleChange}
                    placeholder="From Date"
                    error={errors.from_date}
                  />
                  <DateInputField
                    label="To Date:"
                    name="to_date"
                    value={formData.to_date}
                    onChange={handleChange}
                    placeholder="To Date"
                    error={errors.to_date}
                  />
                </>
              )}
            </Col>
            <Col xl={8} lg={8} className="container-col">
              {(formData.type?.value === 2 ||
                formData.type?.value === 3 ||
                formData.type?.value === 4) && (
                <GridComponent
                  ref={gridRef}
                  className="custom-grid1 pt-10"
                  dataSource={Sns}
                  height="calc(60vh - 180px)"
                  allowResizing
                  allowSorting
                  allowSelection={formData.type.value !== 4}
                  //  recordDoubleClick={handleRowDoubled}
                  rowHeight={24}
                  rowDeselected={handleRowSelected}
                  rowSelected={handleRowSelected}
                >
                  <ColumnsDirective>
                    {snsGrid.map((item, index) => (
                      <ColumnDirective key={index} {...item} />
                    ))}
                  </ColumnsDirective>
                  <Inject services={[Resize, Sort]} />
                </GridComponent>
              )}
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-8">
        {(formData.type?.value === 5 ||
          formData.type?.value === 6 ||
          formData.type?.value === 7 ||
          formData.type?.value === 9 ||
          formData.type?.value === 10) && (
          <Button
            margin="10px"
            padding="20px"
            text="Generate Excel"
            onClick={handleSubmitExc}
            disabled={loadBtn}
          />
        )}
        <Button
          margin="10px"
          padding="20px"
          text="Print PDF"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Close"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default GpuWbReport;
